/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWARCertificatedTransactionCycle = /* GraphQL */ `
  mutation CreateWARCertificatedTransactionCycle(
    $input: CreateWARCertificatedTransactionCycleInput!
    $condition: ModelWARCertificatedTransactionCycleConditionInput
  ) {
    createWARCertificatedTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      remark
      customUpdatedAt
      isApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateWARCertificatedTransactionCycle = /* GraphQL */ `
  mutation UpdateWARCertificatedTransactionCycle(
    $input: UpdateWARCertificatedTransactionCycleInput!
    $condition: ModelWARCertificatedTransactionCycleConditionInput
  ) {
    updateWARCertificatedTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      remark
      customUpdatedAt
      isApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteWARCertificatedTransactionCycle = /* GraphQL */ `
  mutation DeleteWARCertificatedTransactionCycle(
    $input: DeleteWARCertificatedTransactionCycleInput!
    $condition: ModelWARCertificatedTransactionCycleConditionInput
  ) {
    deleteWARCertificatedTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      remark
      customUpdatedAt
      isApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createWARClassifiedTransactionCycle = /* GraphQL */ `
  mutation CreateWARClassifiedTransactionCycle(
    $input: CreateWARClassifiedTransactionCycleInput!
    $condition: ModelWARClassifiedTransactionCycleConditionInput
  ) {
    createWARClassifiedTransactionCycle(input: $input, condition: $condition) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      customUpdatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateWARClassifiedTransactionCycle = /* GraphQL */ `
  mutation UpdateWARClassifiedTransactionCycle(
    $input: UpdateWARClassifiedTransactionCycleInput!
    $condition: ModelWARClassifiedTransactionCycleConditionInput
  ) {
    updateWARClassifiedTransactionCycle(input: $input, condition: $condition) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      customUpdatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteWARClassifiedTransactionCycle = /* GraphQL */ `
  mutation DeleteWARClassifiedTransactionCycle(
    $input: DeleteWARClassifiedTransactionCycleInput!
    $condition: ModelWARClassifiedTransactionCycleConditionInput
  ) {
    deleteWARClassifiedTransactionCycle(input: $input, condition: $condition) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      customUpdatedAt
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPSAPartyDocument = /* GraphQL */ `
  mutation CreatePSAPartyDocument(
    $input: CreatePSAPartyDocumentInput!
    $condition: ModelPSAPartyDocumentConditionInput
  ) {
    createPSAPartyDocument(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePSAPartyDocument = /* GraphQL */ `
  mutation UpdatePSAPartyDocument(
    $input: UpdatePSAPartyDocumentInput!
    $condition: ModelPSAPartyDocumentConditionInput
  ) {
    updatePSAPartyDocument(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePSAPartyDocument = /* GraphQL */ `
  mutation DeletePSAPartyDocument(
    $input: DeletePSAPartyDocumentInput!
    $condition: ModelPSAPartyDocumentConditionInput
  ) {
    deletePSAPartyDocument(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPSADocuments = /* GraphQL */ `
  mutation CreatePSADocuments(
    $input: CreatePSADocumentsInput!
    $condition: ModelPSADocumentsConditionInput
  ) {
    createPSADocuments(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePSADocuments = /* GraphQL */ `
  mutation UpdatePSADocuments(
    $input: UpdatePSADocumentsInput!
    $condition: ModelPSADocumentsConditionInput
  ) {
    updatePSADocuments(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePSADocuments = /* GraphQL */ `
  mutation DeletePSADocuments(
    $input: DeletePSADocumentsInput!
    $condition: ModelPSADocumentsConditionInput
  ) {
    deletePSADocuments(input: $input, condition: $condition) {
      id
      reportId
      filename
      filepath
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonnelActionFormBudgetCode = /* GraphQL */ `
  mutation CreatePersonnelActionFormBudgetCode(
    $input: CreatePersonnelActionFormBudgetCodeInput!
    $condition: ModelPersonnelActionFormBudgetCodeConditionInput
  ) {
    createPersonnelActionFormBudgetCode(input: $input, condition: $condition) {
      id
      employeesId
      budgetCodes
      budgetName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonnelActionFormBudgetCode = /* GraphQL */ `
  mutation UpdatePersonnelActionFormBudgetCode(
    $input: UpdatePersonnelActionFormBudgetCodeInput!
    $condition: ModelPersonnelActionFormBudgetCodeConditionInput
  ) {
    updatePersonnelActionFormBudgetCode(input: $input, condition: $condition) {
      id
      employeesId
      budgetCodes
      budgetName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonnelActionFormBudgetCode = /* GraphQL */ `
  mutation DeletePersonnelActionFormBudgetCode(
    $input: DeletePersonnelActionFormBudgetCodeInput!
    $condition: ModelPersonnelActionFormBudgetCodeConditionInput
  ) {
    deletePersonnelActionFormBudgetCode(input: $input, condition: $condition) {
      id
      employeesId
      budgetCodes
      budgetName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserAdditionalSettings = /* GraphQL */ `
  mutation CreateUserAdditionalSettings(
    $input: CreateUserAdditionalSettingsInput!
    $condition: ModelUserAdditionalSettingsConditionInput
  ) {
    createUserAdditionalSettings(input: $input, condition: $condition) {
      id
      userId
      stipendApprover
      stipendInitiator
      stipendPayroll
      subReqClassifiedInitiator
      subReqClassifiedApprover
      subReqClassifiedPayroll
      personnelServiceAgreeInitiator
      personnelServiceAgreeApprover
      personnelServiceAgreePayroll
      subReqClassifiedSuperAdmin
      isWARClassifiedSuperAdmin
      isWARCertificatedSuperAdmin
      isStipendSuperAdmin
      isSixthPeriodSuperAdmin
      isPersonalServiceSuperAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserAdditionalSettings = /* GraphQL */ `
  mutation UpdateUserAdditionalSettings(
    $input: UpdateUserAdditionalSettingsInput!
    $condition: ModelUserAdditionalSettingsConditionInput
  ) {
    updateUserAdditionalSettings(input: $input, condition: $condition) {
      id
      userId
      stipendApprover
      stipendInitiator
      stipendPayroll
      subReqClassifiedInitiator
      subReqClassifiedApprover
      subReqClassifiedPayroll
      personnelServiceAgreeInitiator
      personnelServiceAgreeApprover
      personnelServiceAgreePayroll
      subReqClassifiedSuperAdmin
      isWARClassifiedSuperAdmin
      isWARCertificatedSuperAdmin
      isStipendSuperAdmin
      isSixthPeriodSuperAdmin
      isPersonalServiceSuperAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserAdditionalSettings = /* GraphQL */ `
  mutation DeleteUserAdditionalSettings(
    $input: DeleteUserAdditionalSettingsInput!
    $condition: ModelUserAdditionalSettingsConditionInput
  ) {
    deleteUserAdditionalSettings(input: $input, condition: $condition) {
      id
      userId
      stipendApprover
      stipendInitiator
      stipendPayroll
      subReqClassifiedInitiator
      subReqClassifiedApprover
      subReqClassifiedPayroll
      personnelServiceAgreeInitiator
      personnelServiceAgreeApprover
      personnelServiceAgreePayroll
      subReqClassifiedSuperAdmin
      isWARClassifiedSuperAdmin
      isWARCertificatedSuperAdmin
      isStipendSuperAdmin
      isSixthPeriodSuperAdmin
      isPersonalServiceSuperAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createLoginEmail = /* GraphQL */ `
  mutation CreateLoginEmail(
    $input: CreateLoginEmailInput!
    $condition: ModelLoginEmailConditionInput
  ) {
    createLoginEmail(input: $input, condition: $condition) {
      id
      firstName
      email
      password
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateLoginEmail = /* GraphQL */ `
  mutation UpdateLoginEmail(
    $input: UpdateLoginEmailInput!
    $condition: ModelLoginEmailConditionInput
  ) {
    updateLoginEmail(input: $input, condition: $condition) {
      id
      firstName
      email
      password
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteLoginEmail = /* GraphQL */ `
  mutation DeleteLoginEmail(
    $input: DeleteLoginEmailInput!
    $condition: ModelLoginEmailConditionInput
  ) {
    deleteLoginEmail(input: $input, condition: $condition) {
      id
      firstName
      email
      password
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonnelActionEmployee = /* GraphQL */ `
  mutation CreatePersonnelActionEmployee(
    $input: CreatePersonnelActionEmployeeInput!
    $condition: ModelPersonnelActionEmployeeConditionInput
  ) {
    createPersonnelActionEmployee(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      created_by
      submited_by
      formId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonnelActionEmployee = /* GraphQL */ `
  mutation UpdatePersonnelActionEmployee(
    $input: UpdatePersonnelActionEmployeeInput!
    $condition: ModelPersonnelActionEmployeeConditionInput
  ) {
    updatePersonnelActionEmployee(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      created_by
      submited_by
      formId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonnelActionEmployee = /* GraphQL */ `
  mutation DeletePersonnelActionEmployee(
    $input: DeletePersonnelActionEmployeeInput!
    $condition: ModelPersonnelActionEmployeeConditionInput
  ) {
    deletePersonnelActionEmployee(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      created_by
      submited_by
      formId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTransactionCyclePersonnel = /* GraphQL */ `
  mutation CreateTransactionCyclePersonnel(
    $input: CreateTransactionCyclePersonnelInput!
    $condition: ModelTransactionCyclePersonnelConditionInput
  ) {
    createTransactionCyclePersonnel(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTransactionCyclePersonnel = /* GraphQL */ `
  mutation UpdateTransactionCyclePersonnel(
    $input: UpdateTransactionCyclePersonnelInput!
    $condition: ModelTransactionCyclePersonnelConditionInput
  ) {
    updateTransactionCyclePersonnel(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTransactionCyclePersonnel = /* GraphQL */ `
  mutation DeleteTransactionCyclePersonnel(
    $input: DeleteTransactionCyclePersonnelInput!
    $condition: ModelTransactionCyclePersonnelConditionInput
  ) {
    deleteTransactionCyclePersonnel(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPreSignupEmployeeApps = /* GraphQL */ `
  mutation CreatePreSignupEmployeeApps(
    $input: CreatePreSignupEmployeeAppsInput!
    $condition: ModelPreSignupEmployeeAppsConditionInput
  ) {
    createPreSignupEmployeeApps(input: $input, condition: $condition) {
      id
      email
      appId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePreSignupEmployeeApps = /* GraphQL */ `
  mutation UpdatePreSignupEmployeeApps(
    $input: UpdatePreSignupEmployeeAppsInput!
    $condition: ModelPreSignupEmployeeAppsConditionInput
  ) {
    updatePreSignupEmployeeApps(input: $input, condition: $condition) {
      id
      email
      appId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePreSignupEmployeeApps = /* GraphQL */ `
  mutation DeletePreSignupEmployeeApps(
    $input: DeletePreSignupEmployeeAppsInput!
    $condition: ModelPreSignupEmployeeAppsConditionInput
  ) {
    deletePreSignupEmployeeApps(input: $input, condition: $condition) {
      id
      email
      appId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPreSignupEmployee = /* GraphQL */ `
  mutation CreatePreSignupEmployee(
    $input: CreatePreSignupEmployeeInput!
    $condition: ModelPreSignupEmployeeConditionInput
  ) {
    createPreSignupEmployee(input: $input, condition: $condition) {
      id
      email
      role
      reportingMangerEmail
      employeeCode
      employeeName
      schoolCode
      userType
      isSixPeriodSAdmin
      sixPeriodIsInitiator
      sixPeriodIsApprover
      sixPeriodIsPayroll
      certiSubRIsInitiator
      certiSubReIsApprover
      certiSubReqIsPayroll
      designation
      isUser
      timeRIsInitiator
      timeRIsApprover
      timeRIsPayroll
      timeRIsSAdmin
      stipendInitiator
      stipendApprover
      stipendPayroll
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePreSignupEmployee = /* GraphQL */ `
  mutation UpdatePreSignupEmployee(
    $input: UpdatePreSignupEmployeeInput!
    $condition: ModelPreSignupEmployeeConditionInput
  ) {
    updatePreSignupEmployee(input: $input, condition: $condition) {
      id
      email
      role
      reportingMangerEmail
      employeeCode
      employeeName
      schoolCode
      userType
      isSixPeriodSAdmin
      sixPeriodIsInitiator
      sixPeriodIsApprover
      sixPeriodIsPayroll
      certiSubRIsInitiator
      certiSubReIsApprover
      certiSubReqIsPayroll
      designation
      isUser
      timeRIsInitiator
      timeRIsApprover
      timeRIsPayroll
      timeRIsSAdmin
      stipendInitiator
      stipendApprover
      stipendPayroll
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePreSignupEmployee = /* GraphQL */ `
  mutation DeletePreSignupEmployee(
    $input: DeletePreSignupEmployeeInput!
    $condition: ModelPreSignupEmployeeConditionInput
  ) {
    deletePreSignupEmployee(input: $input, condition: $condition) {
      id
      email
      role
      reportingMangerEmail
      employeeCode
      employeeName
      schoolCode
      userType
      isSixPeriodSAdmin
      sixPeriodIsInitiator
      sixPeriodIsApprover
      sixPeriodIsPayroll
      certiSubRIsInitiator
      certiSubReIsApprover
      certiSubReqIsPayroll
      designation
      isUser
      timeRIsInitiator
      timeRIsApprover
      timeRIsPayroll
      timeRIsSAdmin
      stipendInitiator
      stipendApprover
      stipendPayroll
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonnelActionTransactionCycle = /* GraphQL */ `
  mutation CreatePersonnelActionTransactionCycle(
    $input: CreatePersonnelActionTransactionCycleInput!
    $condition: ModelPersonnelActionTransactionCycleConditionInput
  ) {
    createPersonnelActionTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonnelActionTransactionCycle = /* GraphQL */ `
  mutation UpdatePersonnelActionTransactionCycle(
    $input: UpdatePersonnelActionTransactionCycleInput!
    $condition: ModelPersonnelActionTransactionCycleConditionInput
  ) {
    updatePersonnelActionTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonnelActionTransactionCycle = /* GraphQL */ `
  mutation DeletePersonnelActionTransactionCycle(
    $input: DeletePersonnelActionTransactionCycleInput!
    $condition: ModelPersonnelActionTransactionCycleConditionInput
  ) {
    deletePersonnelActionTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonnelActionFormTransactionCycle = /* GraphQL */ `
  mutation CreatePersonnelActionFormTransactionCycle(
    $input: CreatePersonnelActionFormTransactionCycleInput!
    $condition: ModelPersonnelActionFormTransactionCycleConditionInput
  ) {
    createPersonnelActionFormTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonnelActionFormTransactionCycle = /* GraphQL */ `
  mutation UpdatePersonnelActionFormTransactionCycle(
    $input: UpdatePersonnelActionFormTransactionCycleInput!
    $condition: ModelPersonnelActionFormTransactionCycleConditionInput
  ) {
    updatePersonnelActionFormTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonnelActionFormTransactionCycle = /* GraphQL */ `
  mutation DeletePersonnelActionFormTransactionCycle(
    $input: DeletePersonnelActionFormTransactionCycleInput!
    $condition: ModelPersonnelActionFormTransactionCycleConditionInput
  ) {
    deletePersonnelActionFormTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      isApproved
      remark
      date
      status
      signature_File_Path
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonnelActionInitiatorForm = /* GraphQL */ `
  mutation CreatePersonnelActionInitiatorForm(
    $input: CreatePersonnelActionInitiatorFormInput!
    $condition: ModelPersonnelActionInitiatorFormConditionInput
  ) {
    createPersonnelActionInitiatorForm(input: $input, condition: $condition) {
      id
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      submited_by
      created_by
      hrTechnician
      executivedirelemId
      assignelemorsec
      psayesorno
      actionDate
      actionItem
      actionPage
      referenceNo
      isDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonnelActionInitiatorForm = /* GraphQL */ `
  mutation UpdatePersonnelActionInitiatorForm(
    $input: UpdatePersonnelActionInitiatorFormInput!
    $condition: ModelPersonnelActionInitiatorFormConditionInput
  ) {
    updatePersonnelActionInitiatorForm(input: $input, condition: $condition) {
      id
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      submited_by
      created_by
      hrTechnician
      executivedirelemId
      assignelemorsec
      psayesorno
      actionDate
      actionItem
      actionPage
      referenceNo
      isDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonnelActionInitiatorForm = /* GraphQL */ `
  mutation DeletePersonnelActionInitiatorForm(
    $input: DeletePersonnelActionInitiatorFormInput!
    $condition: ModelPersonnelActionInitiatorFormConditionInput
  ) {
    deletePersonnelActionInitiatorForm(input: $input, condition: $condition) {
      id
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      submited_by
      created_by
      hrTechnician
      executivedirelemId
      assignelemorsec
      psayesorno
      actionDate
      actionItem
      actionPage
      referenceNo
      isDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserAppsPermission = /* GraphQL */ `
  mutation CreateUserAppsPermission(
    $input: CreateUserAppsPermissionInput!
    $condition: ModelUserAppsPermissionConditionInput
  ) {
    createUserAppsPermission(input: $input, condition: $condition) {
      id
      AppId
      UserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserAppsPermission = /* GraphQL */ `
  mutation UpdateUserAppsPermission(
    $input: UpdateUserAppsPermissionInput!
    $condition: ModelUserAppsPermissionConditionInput
  ) {
    updateUserAppsPermission(input: $input, condition: $condition) {
      id
      AppId
      UserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserAppsPermission = /* GraphQL */ `
  mutation DeleteUserAppsPermission(
    $input: DeleteUserAppsPermissionInput!
    $condition: ModelUserAppsPermissionConditionInput
  ) {
    deleteUserAppsPermission(input: $input, condition: $condition) {
      id
      AppId
      UserId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPSATransactionCycle = /* GraphQL */ `
  mutation CreatePSATransactionCycle(
    $input: CreatePSATransactionCycleInput!
    $condition: ModelPSATransactionCycleConditionInput
  ) {
    createPSATransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      dateTime
      approver_level
      designation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePSATransactionCycle = /* GraphQL */ `
  mutation UpdatePSATransactionCycle(
    $input: UpdatePSATransactionCycleInput!
    $condition: ModelPSATransactionCycleConditionInput
  ) {
    updatePSATransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      dateTime
      approver_level
      designation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePSATransactionCycle = /* GraphQL */ `
  mutation DeletePSATransactionCycle(
    $input: DeletePSATransactionCycleInput!
    $condition: ModelPSATransactionCycleConditionInput
  ) {
    deletePSATransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      dateTime
      approver_level
      designation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPSAParty = /* GraphQL */ `
  mutation CreatePSAParty(
    $input: CreatePSAPartyInput!
    $condition: ModelPSAPartyConditionInput
  ) {
    createPSAParty(input: $input, condition: $condition) {
      id
      party
      pocName
      pocNumber
      email
      clientId
      employerID
      ssn
      typeBE
      license
      state
      city
      address
      zip
      psaConsultantId
      title
      filename
      filename2
      strs
      calpers
      w9File
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePSAParty = /* GraphQL */ `
  mutation UpdatePSAParty(
    $input: UpdatePSAPartyInput!
    $condition: ModelPSAPartyConditionInput
  ) {
    updatePSAParty(input: $input, condition: $condition) {
      id
      party
      pocName
      pocNumber
      email
      clientId
      employerID
      ssn
      typeBE
      license
      state
      city
      address
      zip
      psaConsultantId
      title
      filename
      filename2
      strs
      calpers
      w9File
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePSAParty = /* GraphQL */ `
  mutation DeletePSAParty(
    $input: DeletePSAPartyInput!
    $condition: ModelPSAPartyConditionInput
  ) {
    deletePSAParty(input: $input, condition: $condition) {
      id
      party
      pocName
      pocNumber
      email
      clientId
      employerID
      ssn
      typeBE
      license
      state
      city
      address
      zip
      psaConsultantId
      title
      filename
      filename2
      strs
      calpers
      w9File
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPSAConsultant = /* GraphQL */ `
  mutation CreatePSAConsultant(
    $input: CreatePSAConsultantInput!
    $condition: ModelPSAConsultantConditionInput
  ) {
    createPSAConsultant(input: $input, condition: $condition) {
      id
      assignmentTitle
      department
      agreementDate
      amount
      effectiveDate
      expireDate
      reviewDate
      notifyDays
      submittedTo
      accountNo
      dateofboard
      boardItem
      pageItem
      services
      budgetClerk
      hrConsultant
      executive
      hrexecutive
      psaEmail
      filename
      notes
      otherRemark
      status
      otp
      createdBy
      businessEntity
      addendum
      purchaseOrderNo
      addendumNo
      referenceNo
      submittedCompletedFormTo
      budgetManager
      dateOfApprove
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePSAConsultant = /* GraphQL */ `
  mutation UpdatePSAConsultant(
    $input: UpdatePSAConsultantInput!
    $condition: ModelPSAConsultantConditionInput
  ) {
    updatePSAConsultant(input: $input, condition: $condition) {
      id
      assignmentTitle
      department
      agreementDate
      amount
      effectiveDate
      expireDate
      reviewDate
      notifyDays
      submittedTo
      accountNo
      dateofboard
      boardItem
      pageItem
      services
      budgetClerk
      hrConsultant
      executive
      hrexecutive
      psaEmail
      filename
      notes
      otherRemark
      status
      otp
      createdBy
      businessEntity
      addendum
      purchaseOrderNo
      addendumNo
      referenceNo
      submittedCompletedFormTo
      budgetManager
      dateOfApprove
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePSAConsultant = /* GraphQL */ `
  mutation DeletePSAConsultant(
    $input: DeletePSAConsultantInput!
    $condition: ModelPSAConsultantConditionInput
  ) {
    deletePSAConsultant(input: $input, condition: $condition) {
      id
      assignmentTitle
      department
      agreementDate
      amount
      effectiveDate
      expireDate
      reviewDate
      notifyDays
      submittedTo
      accountNo
      dateofboard
      boardItem
      pageItem
      services
      budgetClerk
      hrConsultant
      executive
      hrexecutive
      psaEmail
      filename
      notes
      otherRemark
      status
      otp
      createdBy
      businessEntity
      addendum
      purchaseOrderNo
      addendumNo
      referenceNo
      submittedCompletedFormTo
      budgetManager
      dateOfApprove
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createStipendTransactionCycle = /* GraphQL */ `
  mutation CreateStipendTransactionCycle(
    $input: CreateStipendTransactionCycleInput!
    $condition: ModelStipendTransactionCycleConditionInput
  ) {
    createStipendTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      ccEmail
      rejectedBy
      submittedDate
      toEmployeeDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateStipendTransactionCycle = /* GraphQL */ `
  mutation UpdateStipendTransactionCycle(
    $input: UpdateStipendTransactionCycleInput!
    $condition: ModelStipendTransactionCycleConditionInput
  ) {
    updateStipendTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      ccEmail
      rejectedBy
      submittedDate
      toEmployeeDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteStipendTransactionCycle = /* GraphQL */ `
  mutation DeleteStipendTransactionCycle(
    $input: DeleteStipendTransactionCycleInput!
    $condition: ModelStipendTransactionCycleConditionInput
  ) {
    deleteStipendTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      ccEmail
      rejectedBy
      submittedDate
      toEmployeeDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createNotificationReadTable = /* GraphQL */ `
  mutation CreateNotificationReadTable(
    $input: CreateNotificationReadTableInput!
    $condition: ModelNotificationReadTableConditionInput
  ) {
    createNotificationReadTable(input: $input, condition: $condition) {
      id
      read_id
      notification_id
      user_id
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateNotificationReadTable = /* GraphQL */ `
  mutation UpdateNotificationReadTable(
    $input: UpdateNotificationReadTableInput!
    $condition: ModelNotificationReadTableConditionInput
  ) {
    updateNotificationReadTable(input: $input, condition: $condition) {
      id
      read_id
      notification_id
      user_id
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteNotificationReadTable = /* GraphQL */ `
  mutation DeleteNotificationReadTable(
    $input: DeleteNotificationReadTableInput!
    $condition: ModelNotificationReadTableConditionInput
  ) {
    deleteNotificationReadTable(input: $input, condition: $condition) {
      id
      read_id
      notification_id
      user_id
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createNotificationTable = /* GraphQL */ `
  mutation CreateNotificationTable(
    $input: CreateNotificationTableInput!
    $condition: ModelNotificationTableConditionInput
  ) {
    createNotificationTable(input: $input, condition: $condition) {
      id
      notification_type
      user_id
      source_id
      source_typ
      message
      created_at
      AppId
      subject
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateNotificationTable = /* GraphQL */ `
  mutation UpdateNotificationTable(
    $input: UpdateNotificationTableInput!
    $condition: ModelNotificationTableConditionInput
  ) {
    updateNotificationTable(input: $input, condition: $condition) {
      id
      notification_type
      user_id
      source_id
      source_typ
      message
      created_at
      AppId
      subject
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteNotificationTable = /* GraphQL */ `
  mutation DeleteNotificationTable(
    $input: DeleteNotificationTableInput!
    $condition: ModelNotificationTableConditionInput
  ) {
    deleteNotificationTable(input: $input, condition: $condition) {
      id
      notification_type
      user_id
      source_id
      source_typ
      message
      created_at
      AppId
      subject
      read_at
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedSubRequestTransactionCycle = /* GraphQL */ `
  mutation CreateCertificatedSubRequestTransactionCycle(
    $input: CreateCertificatedSubRequestTransactionCycleInput!
    $condition: ModelCertificatedSubRequestTransactionCycleConditionInput
  ) {
    createCertificatedSubRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      approver_level
      signature_File_Path
      customUpdatedAt
      approverLevel
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedSubRequestTransactionCycle = /* GraphQL */ `
  mutation UpdateCertificatedSubRequestTransactionCycle(
    $input: UpdateCertificatedSubRequestTransactionCycleInput!
    $condition: ModelCertificatedSubRequestTransactionCycleConditionInput
  ) {
    updateCertificatedSubRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      approver_level
      signature_File_Path
      customUpdatedAt
      approverLevel
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedSubRequestTransactionCycle = /* GraphQL */ `
  mutation DeleteCertificatedSubRequestTransactionCycle(
    $input: DeleteCertificatedSubRequestTransactionCycleInput!
    $condition: ModelCertificatedSubRequestTransactionCycleConditionInput
  ) {
    deleteCertificatedSubRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      approver_level
      signature_File_Path
      customUpdatedAt
      approverLevel
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createPersonalActionForm = /* GraphQL */ `
  mutation CreatePersonalActionForm(
    $input: CreatePersonalActionFormInput!
    $condition: ModelPersonalActionFormConditionInput
  ) {
    createPersonalActionForm(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      positionTitle
      effectiveDates
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      formId
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      created_by
      submited_by
      isArchivedUsers
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updatePersonalActionForm = /* GraphQL */ `
  mutation UpdatePersonalActionForm(
    $input: UpdatePersonalActionFormInput!
    $condition: ModelPersonalActionFormConditionInput
  ) {
    updatePersonalActionForm(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      positionTitle
      effectiveDates
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      formId
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      created_by
      submited_by
      isArchivedUsers
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deletePersonalActionForm = /* GraphQL */ `
  mutation DeletePersonalActionForm(
    $input: DeletePersonalActionFormInput!
    $condition: ModelPersonalActionFormConditionInput
  ) {
    deletePersonalActionForm(input: $input, condition: $condition) {
      id
      employeeId
      employeeName
      positionTitle
      effectiveDates
      salaryRate
      rateofPay
      reason
      fundingSource
      accountNo
      budgetCode
      formId
      effectiveDatesTo
      effectiveDatesFrom
      positionTitleTo
      positionTitleFrom
      formTitle
      boardMeetingDate
      location
      actionToBeTaken
      type
      personalReportNo
      deptHead
      budgetClerk
      budgetManager
      executiveSecretary
      executiveManagement
      created_by
      submited_by
      isArchivedUsers
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createHandbookAssignee = /* GraphQL */ `
  mutation CreateHandbookAssignee(
    $input: CreateHandbookAssigneeInput!
    $condition: ModelHandbookAssigneeConditionInput
  ) {
    createHandbookAssignee(input: $input, condition: $condition) {
      id
      handbook_id
      emp_id
      status
      acknowledge_date
      due_date
      created_by
      created_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateHandbookAssignee = /* GraphQL */ `
  mutation UpdateHandbookAssignee(
    $input: UpdateHandbookAssigneeInput!
    $condition: ModelHandbookAssigneeConditionInput
  ) {
    updateHandbookAssignee(input: $input, condition: $condition) {
      id
      handbook_id
      emp_id
      status
      acknowledge_date
      due_date
      created_by
      created_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteHandbookAssignee = /* GraphQL */ `
  mutation DeleteHandbookAssignee(
    $input: DeleteHandbookAssigneeInput!
    $condition: ModelHandbookAssigneeConditionInput
  ) {
    deleteHandbookAssignee(input: $input, condition: $condition) {
      id
      handbook_id
      emp_id
      status
      acknowledge_date
      due_date
      created_by
      created_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createHandbook = /* GraphQL */ `
  mutation CreateHandbook(
    $input: CreateHandbookInput!
    $condition: ModelHandbookConditionInput
  ) {
    createHandbook(input: $input, condition: $condition) {
      id
      handbook_name
      description
      file_path
      created_date
      created_by
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateHandbook = /* GraphQL */ `
  mutation UpdateHandbook(
    $input: UpdateHandbookInput!
    $condition: ModelHandbookConditionInput
  ) {
    updateHandbook(input: $input, condition: $condition) {
      id
      handbook_name
      description
      file_path
      created_date
      created_by
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteHandbook = /* GraphQL */ `
  mutation DeleteHandbook(
    $input: DeleteHandbookInput!
    $condition: ModelHandbookConditionInput
  ) {
    deleteHandbook(input: $input, condition: $condition) {
      id
      handbook_name
      description
      file_path
      created_date
      created_by
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  mutation CreateCertificatedSubRequestFundingAccountDetails(
    $input: CreateCertificatedSubRequestFundingAccountDetailsInput!
    $condition: ModelCertificatedSubRequestFundingAccountDetailsConditionInput
  ) {
    createCertificatedSubRequestFundingAccountDetails(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fundingAccountTypeId
      accountNumber
      noteIfSpecify
      remarks
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  mutation UpdateCertificatedSubRequestFundingAccountDetails(
    $input: UpdateCertificatedSubRequestFundingAccountDetailsInput!
    $condition: ModelCertificatedSubRequestFundingAccountDetailsConditionInput
  ) {
    updateCertificatedSubRequestFundingAccountDetails(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fundingAccountTypeId
      accountNumber
      noteIfSpecify
      remarks
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedSubRequestFundingAccountDetails = /* GraphQL */ `
  mutation DeleteCertificatedSubRequestFundingAccountDetails(
    $input: DeleteCertificatedSubRequestFundingAccountDetailsInput!
    $condition: ModelCertificatedSubRequestFundingAccountDetailsConditionInput
  ) {
    deleteCertificatedSubRequestFundingAccountDetails(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fundingAccountTypeId
      accountNumber
      noteIfSpecify
      remarks
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createFundingAccountType = /* GraphQL */ `
  mutation CreateFundingAccountType(
    $input: CreateFundingAccountTypeInput!
    $condition: ModelFundingAccountTypeConditionInput
  ) {
    createFundingAccountType(input: $input, condition: $condition) {
      id
      fundingAccountType
      isSpecify
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateFundingAccountType = /* GraphQL */ `
  mutation UpdateFundingAccountType(
    $input: UpdateFundingAccountTypeInput!
    $condition: ModelFundingAccountTypeConditionInput
  ) {
    updateFundingAccountType(input: $input, condition: $condition) {
      id
      fundingAccountType
      isSpecify
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteFundingAccountType = /* GraphQL */ `
  mutation DeleteFundingAccountType(
    $input: DeleteFundingAccountTypeInput!
    $condition: ModelFundingAccountTypeConditionInput
  ) {
    deleteFundingAccountType(input: $input, condition: $condition) {
      id
      fundingAccountType
      isSpecify
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  mutation CreateCertificatedSubRequestSpecificTeacherDates(
    $input: CreateCertificatedSubRequestSpecificTeacherDatesInput!
    $condition: ModelCertificatedSubRequestSpecificTeacherDatesConditionInput
  ) {
    createCertificatedSubRequestSpecificTeacherDates(
      input: $input
      condition: $condition
    ) {
      id
      teacherId
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  mutation UpdateCertificatedSubRequestSpecificTeacherDates(
    $input: UpdateCertificatedSubRequestSpecificTeacherDatesInput!
    $condition: ModelCertificatedSubRequestSpecificTeacherDatesConditionInput
  ) {
    updateCertificatedSubRequestSpecificTeacherDates(
      input: $input
      condition: $condition
    ) {
      id
      teacherId
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedSubRequestSpecificTeacherDates = /* GraphQL */ `
  mutation DeleteCertificatedSubRequestSpecificTeacherDates(
    $input: DeleteCertificatedSubRequestSpecificTeacherDatesInput!
    $condition: ModelCertificatedSubRequestSpecificTeacherDatesConditionInput
  ) {
    deleteCertificatedSubRequestSpecificTeacherDates(
      input: $input
      condition: $condition
    ) {
      id
      teacherId
      date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedSubRequestTeacherData = /* GraphQL */ `
  mutation CreateCertificatedSubRequestTeacherData(
    $input: CreateCertificatedSubRequestTeacherDataInput!
    $condition: ModelCertificatedSubRequestTeacherDataConditionInput
  ) {
    createCertificatedSubRequestTeacherData(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      teacherId
      indicateIf
      gradeOrSubject
      note
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedSubRequestTeacherData = /* GraphQL */ `
  mutation UpdateCertificatedSubRequestTeacherData(
    $input: UpdateCertificatedSubRequestTeacherDataInput!
    $condition: ModelCertificatedSubRequestTeacherDataConditionInput
  ) {
    updateCertificatedSubRequestTeacherData(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      teacherId
      indicateIf
      gradeOrSubject
      note
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedSubRequestTeacherData = /* GraphQL */ `
  mutation DeleteCertificatedSubRequestTeacherData(
    $input: DeleteCertificatedSubRequestTeacherDataInput!
    $condition: ModelCertificatedSubRequestTeacherDataConditionInput
  ) {
    deleteCertificatedSubRequestTeacherData(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      teacherId
      indicateIf
      gradeOrSubject
      note
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedSubInitiateRequest = /* GraphQL */ `
  mutation CreateCertificatedSubInitiateRequest(
    $input: CreateCertificatedSubInitiateRequestInput!
    $condition: ModelCertificatedSubInitiateRequestConditionInput
  ) {
    createCertificatedSubInitiateRequest(input: $input, condition: $condition) {
      id
      schoolOrDeptId
      reportDate
      purposeOfReport
      status
      submittedBy
      submittedOn
      firstApproverId
      secondApproverId
      payrollId
      thirdApproverId
      assighmentTitle
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedSubInitiateRequest = /* GraphQL */ `
  mutation UpdateCertificatedSubInitiateRequest(
    $input: UpdateCertificatedSubInitiateRequestInput!
    $condition: ModelCertificatedSubInitiateRequestConditionInput
  ) {
    updateCertificatedSubInitiateRequest(input: $input, condition: $condition) {
      id
      schoolOrDeptId
      reportDate
      purposeOfReport
      status
      submittedBy
      submittedOn
      firstApproverId
      secondApproverId
      payrollId
      thirdApproverId
      assighmentTitle
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedSubInitiateRequest = /* GraphQL */ `
  mutation DeleteCertificatedSubInitiateRequest(
    $input: DeleteCertificatedSubInitiateRequestInput!
    $condition: ModelCertificatedSubInitiateRequestConditionInput
  ) {
    deleteCertificatedSubInitiateRequest(input: $input, condition: $condition) {
      id
      schoolOrDeptId
      reportDate
      purposeOfReport
      status
      submittedBy
      submittedOn
      firstApproverId
      secondApproverId
      payrollId
      thirdApproverId
      assighmentTitle
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createStipendAssignments = /* GraphQL */ `
  mutation CreateStipendAssignments(
    $input: CreateStipendAssignmentsInput!
    $condition: ModelStipendAssignmentsConditionInput
  ) {
    createStipendAssignments(input: $input, condition: $condition) {
      id
      stipendMasterId
      name
      amount
      isSplit
      splitText
      isExtraCurricular
      isDeptChair
      noOfEmployee
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateStipendAssignments = /* GraphQL */ `
  mutation UpdateStipendAssignments(
    $input: UpdateStipendAssignmentsInput!
    $condition: ModelStipendAssignmentsConditionInput
  ) {
    updateStipendAssignments(input: $input, condition: $condition) {
      id
      stipendMasterId
      name
      amount
      isSplit
      splitText
      isExtraCurricular
      isDeptChair
      noOfEmployee
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteStipendAssignments = /* GraphQL */ `
  mutation DeleteStipendAssignments(
    $input: DeleteStipendAssignmentsInput!
    $condition: ModelStipendAssignmentsConditionInput
  ) {
    deleteStipendAssignments(input: $input, condition: $condition) {
      id
      stipendMasterId
      name
      amount
      isSplit
      splitText
      isExtraCurricular
      isDeptChair
      noOfEmployee
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDepartmentTypeMaster = /* GraphQL */ `
  mutation CreateDepartmentTypeMaster(
    $input: CreateDepartmentTypeMasterInput!
    $condition: ModelDepartmentTypeMasterConditionInput
  ) {
    createDepartmentTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDepartmentTypeMaster = /* GraphQL */ `
  mutation UpdateDepartmentTypeMaster(
    $input: UpdateDepartmentTypeMasterInput!
    $condition: ModelDepartmentTypeMasterConditionInput
  ) {
    updateDepartmentTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDepartmentTypeMaster = /* GraphQL */ `
  mutation DeleteDepartmentTypeMaster(
    $input: DeleteDepartmentTypeMasterInput!
    $condition: ModelDepartmentTypeMasterConditionInput
  ) {
    deleteDepartmentTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createStipendTypeMaster = /* GraphQL */ `
  mutation CreateStipendTypeMaster(
    $input: CreateStipendTypeMasterInput!
    $condition: ModelStipendTypeMasterConditionInput
  ) {
    createStipendTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateStipendTypeMaster = /* GraphQL */ `
  mutation UpdateStipendTypeMaster(
    $input: UpdateStipendTypeMasterInput!
    $condition: ModelStipendTypeMasterConditionInput
  ) {
    updateStipendTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteStipendTypeMaster = /* GraphQL */ `
  mutation DeleteStipendTypeMaster(
    $input: DeleteStipendTypeMasterInput!
    $condition: ModelStipendTypeMasterConditionInput
  ) {
    deleteStipendTypeMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSemisterMaster = /* GraphQL */ `
  mutation CreateSemisterMaster(
    $input: CreateSemisterMasterInput!
    $condition: ModelSemisterMasterConditionInput
  ) {
    createSemisterMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSemisterMaster = /* GraphQL */ `
  mutation UpdateSemisterMaster(
    $input: UpdateSemisterMasterInput!
    $condition: ModelSemisterMasterConditionInput
  ) {
    updateSemisterMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSemisterMaster = /* GraphQL */ `
  mutation DeleteSemisterMaster(
    $input: DeleteSemisterMasterInput!
    $condition: ModelSemisterMasterConditionInput
  ) {
    deleteSemisterMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createYearMaster = /* GraphQL */ `
  mutation CreateYearMaster(
    $input: CreateYearMasterInput!
    $condition: ModelYearMasterConditionInput
  ) {
    createYearMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateYearMaster = /* GraphQL */ `
  mutation UpdateYearMaster(
    $input: UpdateYearMasterInput!
    $condition: ModelYearMasterConditionInput
  ) {
    updateYearMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteYearMaster = /* GraphQL */ `
  mutation DeleteYearMaster(
    $input: DeleteYearMasterInput!
    $condition: ModelYearMasterConditionInput
  ) {
    deleteYearMaster(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createStipendMaster = /* GraphQL */ `
  mutation CreateStipendMaster(
    $input: CreateStipendMasterInput!
    $condition: ModelStipendMasterConditionInput
  ) {
    createStipendMaster(input: $input, condition: $condition) {
      id
      employeeId
      schoolId
      schoolYearId
      semisterId
      stipendAssignmentId
      selfAssignment
      departmentTypeId
      peopleCountInDepartment
      status
      createdBy
      isElementaryStipend
      isMiddleStipend
      isHighStipend
      isDepartmentStipend
      isHeadStipend
      principalId
      hrTechI
      executiveManagerId
      statusStipend
      title
      updatedBy
      remark
      rejectedBy
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateStipendMaster = /* GraphQL */ `
  mutation UpdateStipendMaster(
    $input: UpdateStipendMasterInput!
    $condition: ModelStipendMasterConditionInput
  ) {
    updateStipendMaster(input: $input, condition: $condition) {
      id
      employeeId
      schoolId
      schoolYearId
      semisterId
      stipendAssignmentId
      selfAssignment
      departmentTypeId
      peopleCountInDepartment
      status
      createdBy
      isElementaryStipend
      isMiddleStipend
      isHighStipend
      isDepartmentStipend
      isHeadStipend
      principalId
      hrTechI
      executiveManagerId
      statusStipend
      title
      updatedBy
      remark
      rejectedBy
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteStipendMaster = /* GraphQL */ `
  mutation DeleteStipendMaster(
    $input: DeleteStipendMasterInput!
    $condition: ModelStipendMasterConditionInput
  ) {
    deleteStipendMaster(input: $input, condition: $condition) {
      id
      employeeId
      schoolId
      schoolYearId
      semisterId
      stipendAssignmentId
      selfAssignment
      departmentTypeId
      peopleCountInDepartment
      status
      createdBy
      isElementaryStipend
      isMiddleStipend
      isHighStipend
      isDepartmentStipend
      isHeadStipend
      principalId
      hrTechI
      executiveManagerId
      statusStipend
      title
      updatedBy
      remark
      rejectedBy
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUntitledModel = /* GraphQL */ `
  mutation CreateUntitledModel(
    $input: CreateUntitledModelInput!
    $condition: ModelUntitledModelConditionInput
  ) {
    createUntitledModel(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUntitledModel = /* GraphQL */ `
  mutation UpdateUntitledModel(
    $input: UpdateUntitledModelInput!
    $condition: ModelUntitledModelConditionInput
  ) {
    updateUntitledModel(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUntitledModel = /* GraphQL */ `
  mutation DeleteUntitledModel(
    $input: DeleteUntitledModelInput!
    $condition: ModelUntitledModelConditionInput
  ) {
    deleteUntitledModel(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createClassifiedSubInitiateRequest = /* GraphQL */ `
  mutation CreateClassifiedSubInitiateRequest(
    $input: CreateClassifiedSubInitiateRequestInput!
    $condition: ModelClassifiedSubInitiateRequestConditionInput
  ) {
    createClassifiedSubInitiateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      selectedEmployeeId
      fromDate
      toDate
      typeOfSubReqOrobjCode
      totalWorkingHours
      startTime
      endTime
      locationId
      reasonForAbsenceRequest
      substitude
      confirmed
      firstApproverId
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateClassifiedSubInitiateRequest = /* GraphQL */ `
  mutation UpdateClassifiedSubInitiateRequest(
    $input: UpdateClassifiedSubInitiateRequestInput!
    $condition: ModelClassifiedSubInitiateRequestConditionInput
  ) {
    updateClassifiedSubInitiateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      selectedEmployeeId
      fromDate
      toDate
      typeOfSubReqOrobjCode
      totalWorkingHours
      startTime
      endTime
      locationId
      reasonForAbsenceRequest
      substitude
      confirmed
      firstApproverId
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteClassifiedSubInitiateRequest = /* GraphQL */ `
  mutation DeleteClassifiedSubInitiateRequest(
    $input: DeleteClassifiedSubInitiateRequestInput!
    $condition: ModelClassifiedSubInitiateRequestConditionInput
  ) {
    deleteClassifiedSubInitiateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      selectedEmployeeId
      fromDate
      toDate
      typeOfSubReqOrobjCode
      totalWorkingHours
      startTime
      endTime
      locationId
      reasonForAbsenceRequest
      substitude
      confirmed
      firstApproverId
      status
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createEmployeeHandbook = /* GraphQL */ `
  mutation CreateEmployeeHandbook(
    $input: CreateEmployeeHandbookInput!
    $condition: ModelEmployeeHandbookConditionInput
  ) {
    createEmployeeHandbook(input: $input, condition: $condition) {
      id
      EmployeeName
      EmployeeId
      dateHandbookSend
      dateofAcknowledge
      status
      handbookName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateEmployeeHandbook = /* GraphQL */ `
  mutation UpdateEmployeeHandbook(
    $input: UpdateEmployeeHandbookInput!
    $condition: ModelEmployeeHandbookConditionInput
  ) {
    updateEmployeeHandbook(input: $input, condition: $condition) {
      id
      EmployeeName
      EmployeeId
      dateHandbookSend
      dateofAcknowledge
      status
      handbookName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteEmployeeHandbook = /* GraphQL */ `
  mutation DeleteEmployeeHandbook(
    $input: DeleteEmployeeHandbookInput!
    $condition: ModelEmployeeHandbookConditionInput
  ) {
    deleteEmployeeHandbook(input: $input, condition: $condition) {
      id
      EmployeeName
      EmployeeId
      dateHandbookSend
      dateofAcknowledge
      status
      handbookName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSubstituteCertificateRequestTransactionCycle = /* GraphQL */ `
  mutation CreateSubstituteCertificateRequestTransactionCycle(
    $input: CreateSubstituteCertificateRequestTransactionCycleInput!
    $condition: ModelSubstituteCertificateRequestTransactionCycleConditionInput
  ) {
    createSubstituteCertificateRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubstituteCertificateRequestTransactionCycle = /* GraphQL */ `
  mutation UpdateSubstituteCertificateRequestTransactionCycle(
    $input: UpdateSubstituteCertificateRequestTransactionCycleInput!
    $condition: ModelSubstituteCertificateRequestTransactionCycleConditionInput
  ) {
    updateSubstituteCertificateRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubstituteCertificateRequestTransactionCycle = /* GraphQL */ `
  mutation DeleteSubstituteCertificateRequestTransactionCycle(
    $input: DeleteSubstituteCertificateRequestTransactionCycleInput!
    $condition: ModelSubstituteCertificateRequestTransactionCycleConditionInput
  ) {
    deleteSubstituteCertificateRequestTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      reportId
      fromEmployeeId
      toEmployeeId
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  mutation CreateSubstituteCertificateRequestAccountNoIDs(
    $input: CreateSubstituteCertificateRequestAccountNoIDsInput!
    $condition: ModelSubstituteCertificateRequestAccountNoIDsConditionInput
  ) {
    createSubstituteCertificateRequestAccountNoIDs(
      input: $input
      condition: $condition
    ) {
      id
      substituteCertificateRequestId
      accountNumber
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  mutation UpdateSubstituteCertificateRequestAccountNoIDs(
    $input: UpdateSubstituteCertificateRequestAccountNoIDsInput!
    $condition: ModelSubstituteCertificateRequestAccountNoIDsConditionInput
  ) {
    updateSubstituteCertificateRequestAccountNoIDs(
      input: $input
      condition: $condition
    ) {
      id
      substituteCertificateRequestId
      accountNumber
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubstituteCertificateRequestAccountNoIDs = /* GraphQL */ `
  mutation DeleteSubstituteCertificateRequestAccountNoIDs(
    $input: DeleteSubstituteCertificateRequestAccountNoIDsInput!
    $condition: ModelSubstituteCertificateRequestAccountNoIDsConditionInput
  ) {
    deleteSubstituteCertificateRequestAccountNoIDs(
      input: $input
      condition: $condition
    ) {
      id
      substituteCertificateRequestId
      accountNumber
      percentage
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSubstituteCertificateRequest = /* GraphQL */ `
  mutation CreateSubstituteCertificateRequest(
    $input: CreateSubstituteCertificateRequestInput!
    $condition: ModelSubstituteCertificateRequestConditionInput
  ) {
    createSubstituteCertificateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      employeeCodeId
      fromDate
      toDate
      typeOfSub
      locationId
      reasonForAbsenceRequest
      substitudeName
      isConfirmed
      principleDepartmentHeadString
      createdBy
      CreatedByDateTime
      fromTime
      endTime
      budgetApprover
      payrollHr
      totalWorkingHours
      budgetManager
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubstituteCertificateRequest = /* GraphQL */ `
  mutation UpdateSubstituteCertificateRequest(
    $input: UpdateSubstituteCertificateRequestInput!
    $condition: ModelSubstituteCertificateRequestConditionInput
  ) {
    updateSubstituteCertificateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      employeeCodeId
      fromDate
      toDate
      typeOfSub
      locationId
      reasonForAbsenceRequest
      substitudeName
      isConfirmed
      principleDepartmentHeadString
      createdBy
      CreatedByDateTime
      fromTime
      endTime
      budgetApprover
      payrollHr
      totalWorkingHours
      budgetManager
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubstituteCertificateRequest = /* GraphQL */ `
  mutation DeleteSubstituteCertificateRequest(
    $input: DeleteSubstituteCertificateRequestInput!
    $condition: ModelSubstituteCertificateRequestConditionInput
  ) {
    deleteSubstituteCertificateRequest(input: $input, condition: $condition) {
      id
      assignmentTitle
      classification
      employeeCodeId
      fromDate
      toDate
      typeOfSub
      locationId
      reasonForAbsenceRequest
      substitudeName
      isConfirmed
      principleDepartmentHeadString
      createdBy
      CreatedByDateTime
      fromTime
      endTime
      budgetApprover
      payrollHr
      totalWorkingHours
      budgetManager
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertifiedAdminReportsLog = /* GraphQL */ `
  mutation CreateCertifiedAdminReportsLog(
    $input: CreateCertifiedAdminReportsLogInput!
    $condition: ModelCertifiedAdminReportsLogConditionInput
  ) {
    createCertifiedAdminReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertifiedAdminReportsLog = /* GraphQL */ `
  mutation UpdateCertifiedAdminReportsLog(
    $input: UpdateCertifiedAdminReportsLogInput!
    $condition: ModelCertifiedAdminReportsLogConditionInput
  ) {
    updateCertifiedAdminReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertifiedAdminReportsLog = /* GraphQL */ `
  mutation DeleteCertifiedAdminReportsLog(
    $input: DeleteCertifiedAdminReportsLogInput!
    $condition: ModelCertifiedAdminReportsLogConditionInput
  ) {
    deleteCertifiedAdminReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation CreateCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
    $input: CreateCertificatedAdminWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    createCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_Employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation UpdateCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
    $input: UpdateCertificatedAdminWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    updateCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_Employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation DeleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
    $input: DeleteCertificatedAdminWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    deleteCertificatedAdminWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_Employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedAdminWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation CreateCertificatedAdminWeeklyAbsenceReportEmployee(
    $input: CreateCertificatedAdminWeeklyAbsenceReportEmployeeInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeConditionInput
  ) {
    createCertificatedAdminWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_id
      employee_id
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedAdminWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation UpdateCertificatedAdminWeeklyAbsenceReportEmployee(
    $input: UpdateCertificatedAdminWeeklyAbsenceReportEmployeeInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeConditionInput
  ) {
    updateCertificatedAdminWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_id
      employee_id
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedAdminWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation DeleteCertificatedAdminWeeklyAbsenceReportEmployee(
    $input: DeleteCertificatedAdminWeeklyAbsenceReportEmployeeInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportEmployeeConditionInput
  ) {
    deleteCertificatedAdminWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      Certificated_Admin_Weekly_Absence_Report_id
      employee_id
      employee_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createCertificatedAdminWeeklyAbsenceReport = /* GraphQL */ `
  mutation CreateCertificatedAdminWeeklyAbsenceReport(
    $input: CreateCertificatedAdminWeeklyAbsenceReportInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportConditionInput
  ) {
    createCertificatedAdminWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      user_id
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateCertificatedAdminWeeklyAbsenceReport = /* GraphQL */ `
  mutation UpdateCertificatedAdminWeeklyAbsenceReport(
    $input: UpdateCertificatedAdminWeeklyAbsenceReportInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportConditionInput
  ) {
    updateCertificatedAdminWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      user_id
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteCertificatedAdminWeeklyAbsenceReport = /* GraphQL */ `
  mutation DeleteCertificatedAdminWeeklyAbsenceReport(
    $input: DeleteCertificatedAdminWeeklyAbsenceReportInput!
    $condition: ModelCertificatedAdminWeeklyAbsenceReportConditionInput
  ) {
    deleteCertificatedAdminWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      user_id
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTimeReportTransactionCycle = /* GraphQL */ `
  mutation CreateTimeReportTransactionCycle(
    $input: CreateTimeReportTransactionCycleInput!
    $condition: ModelTimeReportTransactionCycleConditionInput
  ) {
    createTimeReportTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTimeReportTransactionCycle = /* GraphQL */ `
  mutation UpdateTimeReportTransactionCycle(
    $input: UpdateTimeReportTransactionCycleInput!
    $condition: ModelTimeReportTransactionCycleConditionInput
  ) {
    updateTimeReportTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTimeReportTransactionCycle = /* GraphQL */ `
  mutation DeleteTimeReportTransactionCycle(
    $input: DeleteTimeReportTransactionCycleInput!
    $condition: ModelTimeReportTransactionCycleConditionInput
  ) {
    deleteTimeReportTransactionCycle(input: $input, condition: $condition) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      approver_level
      customUpdatedAt
      toEmpDesignation
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createEmployeeType = /* GraphQL */ `
  mutation CreateEmployeeType(
    $input: CreateEmployeeTypeInput!
    $condition: ModelEmployeeTypeConditionInput
  ) {
    createEmployeeType(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateEmployeeType = /* GraphQL */ `
  mutation UpdateEmployeeType(
    $input: UpdateEmployeeTypeInput!
    $condition: ModelEmployeeTypeConditionInput
  ) {
    updateEmployeeType(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteEmployeeType = /* GraphQL */ `
  mutation DeleteEmployeeType(
    $input: DeleteEmployeeTypeInput!
    $condition: ModelEmployeeTypeConditionInput
  ) {
    deleteEmployeeType(input: $input, condition: $condition) {
      id
      untitledfield
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTimeReportEmployeeDetails = /* GraphQL */ `
  mutation CreateTimeReportEmployeeDetails(
    $input: CreateTimeReportEmployeeDetailsInput!
    $condition: ModelTimeReportEmployeeDetailsConditionInput
  ) {
    createTimeReportEmployeeDetails(input: $input, condition: $condition) {
      id
      time_Report_Employee_Id
      date
      totalHours
      totalMin
      totalHoursAndMinDisplay
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTimeReportEmployeeDetails = /* GraphQL */ `
  mutation UpdateTimeReportEmployeeDetails(
    $input: UpdateTimeReportEmployeeDetailsInput!
    $condition: ModelTimeReportEmployeeDetailsConditionInput
  ) {
    updateTimeReportEmployeeDetails(input: $input, condition: $condition) {
      id
      time_Report_Employee_Id
      date
      totalHours
      totalMin
      totalHoursAndMinDisplay
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTimeReportEmployeeDetails = /* GraphQL */ `
  mutation DeleteTimeReportEmployeeDetails(
    $input: DeleteTimeReportEmployeeDetailsInput!
    $condition: ModelTimeReportEmployeeDetailsConditionInput
  ) {
    deleteTimeReportEmployeeDetails(input: $input, condition: $condition) {
      id
      time_Report_Employee_Id
      date
      totalHours
      totalMin
      totalHoursAndMinDisplay
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTimeReportEmployee = /* GraphQL */ `
  mutation CreateTimeReportEmployee(
    $input: CreateTimeReportEmployeeInput!
    $condition: ModelTimeReportEmployeeConditionInput
  ) {
    createTimeReportEmployee(input: $input, condition: $condition) {
      id
      employee_Id
      time_Report_Id
      pay_Rate
      totalEmployeeWorkingHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTimeReportEmployee = /* GraphQL */ `
  mutation UpdateTimeReportEmployee(
    $input: UpdateTimeReportEmployeeInput!
    $condition: ModelTimeReportEmployeeConditionInput
  ) {
    updateTimeReportEmployee(input: $input, condition: $condition) {
      id
      employee_Id
      time_Report_Id
      pay_Rate
      totalEmployeeWorkingHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTimeReportEmployee = /* GraphQL */ `
  mutation DeleteTimeReportEmployee(
    $input: DeleteTimeReportEmployeeInput!
    $condition: ModelTimeReportEmployeeConditionInput
  ) {
    deleteTimeReportEmployee(input: $input, condition: $condition) {
      id
      employee_Id
      time_Report_Id
      pay_Rate
      totalEmployeeWorkingHours
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createTimeReportInitiateReport = /* GraphQL */ `
  mutation CreateTimeReportInitiateReport(
    $input: CreateTimeReportInitiateReportInput!
    $condition: ModelTimeReportInitiateReportConditionInput
  ) {
    createTimeReportInitiateReport(input: $input, condition: $condition) {
      id
      school_Department_Id
      From_Date
      To_Date
      Type
      Account
      Hourly_Rate
      Daily_Rate
      Authorizing_Board_Report_Date
      First_Approveal
      Second_Approveal
      Status
      Created_By
      Created_By_Date
      payroll_id
      validator_id
      pageNo
      Notes
      rateType
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateTimeReportInitiateReport = /* GraphQL */ `
  mutation UpdateTimeReportInitiateReport(
    $input: UpdateTimeReportInitiateReportInput!
    $condition: ModelTimeReportInitiateReportConditionInput
  ) {
    updateTimeReportInitiateReport(input: $input, condition: $condition) {
      id
      school_Department_Id
      From_Date
      To_Date
      Type
      Account
      Hourly_Rate
      Daily_Rate
      Authorizing_Board_Report_Date
      First_Approveal
      Second_Approveal
      Status
      Created_By
      Created_By_Date
      payroll_id
      validator_id
      pageNo
      Notes
      rateType
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteTimeReportInitiateReport = /* GraphQL */ `
  mutation DeleteTimeReportInitiateReport(
    $input: DeleteTimeReportInitiateReportInput!
    $condition: ModelTimeReportInitiateReportConditionInput
  ) {
    deleteTimeReportInitiateReport(input: $input, condition: $condition) {
      id
      school_Department_Id
      From_Date
      To_Date
      Type
      Account
      Hourly_Rate
      Daily_Rate
      Authorizing_Board_Report_Date
      First_Approveal
      Second_Approveal
      Status
      Created_By
      Created_By_Date
      payroll_id
      validator_id
      pageNo
      Notes
      rateType
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSixthPeriodReportTransactionCycle = /* GraphQL */ `
  mutation CreateSixthPeriodReportTransactionCycle(
    $input: CreateSixthPeriodReportTransactionCycleInput!
    $condition: ModelSixthPeriodReportTransactionCycleConditionInput
  ) {
    createSixthPeriodReportTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      customResubmitDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSixthPeriodReportTransactionCycle = /* GraphQL */ `
  mutation UpdateSixthPeriodReportTransactionCycle(
    $input: UpdateSixthPeriodReportTransactionCycleInput!
    $condition: ModelSixthPeriodReportTransactionCycleConditionInput
  ) {
    updateSixthPeriodReportTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      customResubmitDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSixthPeriodReportTransactionCycle = /* GraphQL */ `
  mutation DeleteSixthPeriodReportTransactionCycle(
    $input: DeleteSixthPeriodReportTransactionCycleInput!
    $condition: ModelSixthPeriodReportTransactionCycleConditionInput
  ) {
    deleteSixthPeriodReportTransactionCycle(
      input: $input
      condition: $condition
    ) {
      id
      report_Id
      from_Employee_Id
      to_Employee_Id
      status
      isApproved
      remark
      date
      signature_File_Path
      approver_level
      customResubmitDate
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSubject = /* GraphQL */ `
  mutation CreateSubject(
    $input: CreateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    createSubject(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSubject = /* GraphQL */ `
  mutation UpdateSubject(
    $input: UpdateSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    updateSubject(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSubject = /* GraphQL */ `
  mutation DeleteSubject(
    $input: DeleteSubjectInput!
    $condition: ModelSubjectConditionInput
  ) {
    deleteSubject(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSixthPeriodAssignmentInitiateReport = /* GraphQL */ `
  mutation CreateSixthPeriodAssignmentInitiateReport(
    $input: CreateSixthPeriodAssignmentInitiateReportInput!
    $condition: ModelSixthPeriodAssignmentInitiateReportConditionInput
  ) {
    createSixthPeriodAssignmentInitiateReport(
      input: $input
      condition: $condition
    ) {
      id
      assignment_title
      employee_id
      assighment_at
      from_date
      to_date
      subject_area
      total_staffing_allocation
      account_charged
      current_fte_utilized
      submited_by
      submited_at
      created_by
      particular_emp_reporting_manager
      budgetClerkId
      budgetManagerId
      hrDirectorI
      payrollId
      editable
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSixthPeriodAssignmentInitiateReport = /* GraphQL */ `
  mutation UpdateSixthPeriodAssignmentInitiateReport(
    $input: UpdateSixthPeriodAssignmentInitiateReportInput!
    $condition: ModelSixthPeriodAssignmentInitiateReportConditionInput
  ) {
    updateSixthPeriodAssignmentInitiateReport(
      input: $input
      condition: $condition
    ) {
      id
      assignment_title
      employee_id
      assighment_at
      from_date
      to_date
      subject_area
      total_staffing_allocation
      account_charged
      current_fte_utilized
      submited_by
      submited_at
      created_by
      particular_emp_reporting_manager
      budgetClerkId
      budgetManagerId
      hrDirectorI
      payrollId
      editable
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSixthPeriodAssignmentInitiateReport = /* GraphQL */ `
  mutation DeleteSixthPeriodAssignmentInitiateReport(
    $input: DeleteSixthPeriodAssignmentInitiateReportInput!
    $condition: ModelSixthPeriodAssignmentInitiateReportConditionInput
  ) {
    deleteSixthPeriodAssignmentInitiateReport(
      input: $input
      condition: $condition
    ) {
      id
      assignment_title
      employee_id
      assighment_at
      from_date
      to_date
      subject_area
      total_staffing_allocation
      account_charged
      current_fte_utilized
      submited_by
      submited_at
      created_by
      particular_emp_reporting_manager
      budgetClerkId
      budgetManagerId
      hrDirectorI
      payrollId
      editable
      isSoftDelete
      isArchived
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createReportsLog = /* GraphQL */ `
  mutation CreateReportsLog(
    $input: CreateReportsLogInput!
    $condition: ModelReportsLogConditionInput
  ) {
    createReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateReportsLog = /* GraphQL */ `
  mutation UpdateReportsLog(
    $input: UpdateReportsLogInput!
    $condition: ModelReportsLogConditionInput
  ) {
    updateReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteReportsLog = /* GraphQL */ `
  mutation DeleteReportsLog(
    $input: DeleteReportsLogInput!
    $condition: ModelReportsLogConditionInput
  ) {
    deleteReportsLog(input: $input, condition: $condition) {
      id
      report_id
      comment
      date_and_time
      user_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation CreateInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
    $input: CreateInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    createInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation UpdateInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
    $input: UpdateInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    updateInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteInitiateClassifiedWeeklyAbsenceReportEmployeeDetails = /* GraphQL */ `
  mutation DeleteInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
    $input: DeleteInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeDetailsConditionInput
  ) {
    deleteInitiateClassifiedWeeklyAbsenceReportEmployeeDetails(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_employee_id
      absent_code_id
      substitute_emp_id
      is_full_day
      partial_hour
      partial_min
      absent_date
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createInitiateClassifiedWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation CreateInitiateClassifiedWeeklyAbsenceReportEmployee(
    $input: CreateInitiateClassifiedWeeklyAbsenceReportEmployeeInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeConditionInput
  ) {
    createInitiateClassifiedWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_id
      employee_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateInitiateClassifiedWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation UpdateInitiateClassifiedWeeklyAbsenceReportEmployee(
    $input: UpdateInitiateClassifiedWeeklyAbsenceReportEmployeeInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeConditionInput
  ) {
    updateInitiateClassifiedWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_id
      employee_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteInitiateClassifiedWeeklyAbsenceReportEmployee = /* GraphQL */ `
  mutation DeleteInitiateClassifiedWeeklyAbsenceReportEmployee(
    $input: DeleteInitiateClassifiedWeeklyAbsenceReportEmployeeInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportEmployeeConditionInput
  ) {
    deleteInitiateClassifiedWeeklyAbsenceReportEmployee(
      input: $input
      condition: $condition
    ) {
      id
      initiate_classified_weekly_absence_report_id
      employee_id
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserGroups = /* GraphQL */ `
  mutation CreateUserGroups(
    $input: CreateUserGroupsInput!
    $condition: ModelUserGroupsConditionInput
  ) {
    createUserGroups(input: $input, condition: $condition) {
      id
      user_id
      group_id
      lock_access
      request_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserGroups = /* GraphQL */ `
  mutation UpdateUserGroups(
    $input: UpdateUserGroupsInput!
    $condition: ModelUserGroupsConditionInput
  ) {
    updateUserGroups(input: $input, condition: $condition) {
      id
      user_id
      group_id
      lock_access
      request_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserGroups = /* GraphQL */ `
  mutation DeleteUserGroups(
    $input: DeleteUserGroupsInput!
    $condition: ModelUserGroupsConditionInput
  ) {
    deleteUserGroups(input: $input, condition: $condition) {
      id
      user_id
      group_id
      lock_access
      request_type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createEmployee = /* GraphQL */ `
  mutation CreateEmployee(
    $input: CreateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    createEmployee(input: $input, condition: $condition) {
      id
      employee_name
      employee_code
      school_id
      address_1
      address_2
      city
      zip_code
      country
      phone_no
      email
      state
      employeeType
      user_Id
      designation
      firstName
      lastName
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateEmployee = /* GraphQL */ `
  mutation UpdateEmployee(
    $input: UpdateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    updateEmployee(input: $input, condition: $condition) {
      id
      employee_name
      employee_code
      school_id
      address_1
      address_2
      city
      zip_code
      country
      phone_no
      email
      state
      employeeType
      user_Id
      designation
      firstName
      lastName
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteEmployee = /* GraphQL */ `
  mutation DeleteEmployee(
    $input: DeleteEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    deleteEmployee(input: $input, condition: $condition) {
      id
      employee_name
      employee_code
      school_id
      address_1
      address_2
      city
      zip_code
      country
      phone_no
      email
      state
      employeeType
      user_Id
      designation
      firstName
      lastName
      role
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createRoleAccess = /* GraphQL */ `
  mutation CreateRoleAccess(
    $input: CreateRoleAccessInput!
    $condition: ModelRoleAccessConditionInput
  ) {
    createRoleAccess(input: $input, condition: $condition) {
      id
      name
      parent_id
      sort_order
      is_view_applicable
      is_add_applicable
      is_edit_applicable
      is_delete_applicable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateRoleAccess = /* GraphQL */ `
  mutation UpdateRoleAccess(
    $input: UpdateRoleAccessInput!
    $condition: ModelRoleAccessConditionInput
  ) {
    updateRoleAccess(input: $input, condition: $condition) {
      id
      name
      parent_id
      sort_order
      is_view_applicable
      is_add_applicable
      is_edit_applicable
      is_delete_applicable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteRoleAccess = /* GraphQL */ `
  mutation DeleteRoleAccess(
    $input: DeleteRoleAccessInput!
    $condition: ModelRoleAccessConditionInput
  ) {
    deleteRoleAccess(input: $input, condition: $condition) {
      id
      name
      parent_id
      sort_order
      is_view_applicable
      is_add_applicable
      is_edit_applicable
      is_delete_applicable
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createGroups = /* GraphQL */ `
  mutation CreateGroups(
    $input: CreateGroupsInput!
    $condition: ModelGroupsConditionInput
  ) {
    createGroups(input: $input, condition: $condition) {
      id
      name
      selected_users
      assigned_members_count
      is_access_locked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateGroups = /* GraphQL */ `
  mutation UpdateGroups(
    $input: UpdateGroupsInput!
    $condition: ModelGroupsConditionInput
  ) {
    updateGroups(input: $input, condition: $condition) {
      id
      name
      selected_users
      assigned_members_count
      is_access_locked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteGroups = /* GraphQL */ `
  mutation DeleteGroups(
    $input: DeleteGroupsInput!
    $condition: ModelGroupsConditionInput
  ) {
    deleteGroups(input: $input, condition: $condition) {
      id
      name
      selected_users
      assigned_members_count
      is_access_locked
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createAbsentType = /* GraphQL */ `
  mutation CreateAbsentType(
    $input: CreateAbsentTypeInput!
    $condition: ModelAbsentTypeConditionInput
  ) {
    createAbsentType(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAbsentType = /* GraphQL */ `
  mutation UpdateAbsentType(
    $input: UpdateAbsentTypeInput!
    $condition: ModelAbsentTypeConditionInput
  ) {
    updateAbsentType(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAbsentType = /* GraphQL */ `
  mutation DeleteAbsentType(
    $input: DeleteAbsentTypeInput!
    $condition: ModelAbsentTypeConditionInput
  ) {
    deleteAbsentType(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createInitiateClassifiedWeeklyAbsenceReport = /* GraphQL */ `
  mutation CreateInitiateClassifiedWeeklyAbsenceReport(
    $input: CreateInitiateClassifiedWeeklyAbsenceReportInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportConditionInput
  ) {
    createInitiateClassifiedWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      user_id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      updatedBy
      deletedBy
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateInitiateClassifiedWeeklyAbsenceReport = /* GraphQL */ `
  mutation UpdateInitiateClassifiedWeeklyAbsenceReport(
    $input: UpdateInitiateClassifiedWeeklyAbsenceReportInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportConditionInput
  ) {
    updateInitiateClassifiedWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      user_id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      updatedBy
      deletedBy
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteInitiateClassifiedWeeklyAbsenceReport = /* GraphQL */ `
  mutation DeleteInitiateClassifiedWeeklyAbsenceReport(
    $input: DeleteInitiateClassifiedWeeklyAbsenceReportInput!
    $condition: ModelInitiateClassifiedWeeklyAbsenceReportConditionInput
  ) {
    deleteInitiateClassifiedWeeklyAbsenceReport(
      input: $input
      condition: $condition
    ) {
      id
      user_id
      status
      school_id
      from_date
      to_date
      status_date_time
      approver_status
      approver_by
      approver_date_time
      payroll_status
      payroll_by
      payroll_date_time
      approver_remark
      payroll_remark
      l1_authority
      l2_authority
      comment
      customUpdatedAt
      isSoftDelete
      isArchived
      updatedBy
      deletedBy
      isArchivedUsers
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createAbsentCode = /* GraphQL */ `
  mutation CreateAbsentCode(
    $input: CreateAbsentCodeInput!
    $condition: ModelAbsentCodeConditionInput
  ) {
    createAbsentCode(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateAbsentCode = /* GraphQL */ `
  mutation UpdateAbsentCode(
    $input: UpdateAbsentCodeInput!
    $condition: ModelAbsentCodeConditionInput
  ) {
    updateAbsentCode(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteAbsentCode = /* GraphQL */ `
  mutation DeleteAbsentCode(
    $input: DeleteAbsentCodeInput!
    $condition: ModelAbsentCodeConditionInput
  ) {
    deleteAbsentCode(input: $input, condition: $condition) {
      id
      code
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createGrades = /* GraphQL */ `
  mutation CreateGrades(
    $input: CreateGradesInput!
    $condition: ModelGradesConditionInput
  ) {
    createGrades(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateGrades = /* GraphQL */ `
  mutation UpdateGrades(
    $input: UpdateGradesInput!
    $condition: ModelGradesConditionInput
  ) {
    updateGrades(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteGrades = /* GraphQL */ `
  mutation DeleteGrades(
    $input: DeleteGradesInput!
    $condition: ModelGradesConditionInput
  ) {
    deleteGrades(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createSchools = /* GraphQL */ `
  mutation CreateSchools(
    $input: CreateSchoolsInput!
    $condition: ModelSchoolsConditionInput
  ) {
    createSchools(input: $input, condition: $condition) {
      id
      address
      city
      state_id
      zip_code
      is_active
      code
      name
      isValidator
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateSchools = /* GraphQL */ `
  mutation UpdateSchools(
    $input: UpdateSchoolsInput!
    $condition: ModelSchoolsConditionInput
  ) {
    updateSchools(input: $input, condition: $condition) {
      id
      address
      city
      state_id
      zip_code
      is_active
      code
      name
      isValidator
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteSchools = /* GraphQL */ `
  mutation DeleteSchools(
    $input: DeleteSchoolsInput!
    $condition: ModelSchoolsConditionInput
  ) {
    deleteSchools(input: $input, condition: $condition) {
      id
      address
      city
      state_id
      zip_code
      is_active
      code
      name
      isValidator
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createOrganizations = /* GraphQL */ `
  mutation CreateOrganizations(
    $input: CreateOrganizationsInput!
    $condition: ModelOrganizationsConditionInput
  ) {
    createOrganizations(input: $input, condition: $condition) {
      id
      organization_email
      organization_phone_number
      about_organization
      address
      city
      state_id
      zip_code
      domain_name
      is_active
      name
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateOrganizations = /* GraphQL */ `
  mutation UpdateOrganizations(
    $input: UpdateOrganizationsInput!
    $condition: ModelOrganizationsConditionInput
  ) {
    updateOrganizations(input: $input, condition: $condition) {
      id
      organization_email
      organization_phone_number
      about_organization
      address
      city
      state_id
      zip_code
      domain_name
      is_active
      name
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteOrganizations = /* GraphQL */ `
  mutation DeleteOrganizations(
    $input: DeleteOrganizationsInput!
    $condition: ModelOrganizationsConditionInput
  ) {
    deleteOrganizations(input: $input, condition: $condition) {
      id
      organization_email
      organization_phone_number
      about_organization
      address
      city
      state_id
      zip_code
      domain_name
      is_active
      name
      code
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
